module.exports = __webpack_public_path__ + "static/test-management-office-4fc45ee30be2b8d242161d57f5941467.jpg";